export default __webpack_public_path__ + "static/media/AvataUser.948b3c3c.jpg";